import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

const when = (s) => (s ? new Date(s).toLocaleString('es-CO', { dateStyle: 'short', timeStyle: 'short' }) : null);

// Estado del envío gestionado por AutoMarket, visible para comprador y vendedor.
export const ShipmentTracking = ({ orderId }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/orders/${orderId}/shipment`).then(r => setS(r.data.shipment)).catch(() => {}); }, [orderId]);
  if (!s) return null;
  return (
    <div className="mt-2 border border-sky-200 bg-sky-50 p-2 text-xs text-sky-900" data-testid={`shipment-tracking-${orderId}`}>
      <b>Envío AutoMarket:</b> {s.status_label}
      {s.pickup_at && s.status === 'pickup_scheduled' && <> · recogida {when(s.pickup_at)}</>}
      {s.tracking_code && <> · {s.carrier} guía {s.tracking_code}</>}
      {s.dispatched_at && <> · despachado {when(s.dispatched_at)}</>}
      {s.tracking_url && <> · <a href={s.tracking_url} target="_blank" rel="noopener noreferrer" className="font-semibold underline" data-testid={`shipment-tracking-link-${orderId}`}>Seguir envío</a></>}
    </div>
  );
};
